export { localeStrings as deLocaleStrings } from './de';
export { localeStrings as esLocaleStrings } from './es';
export { localeStrings as csLocaleStrings } from './cs';
export { localeStrings as frLocaleStrings } from './fr';
export { localeStrings as itLocaleStrings } from './it';
export { localeStrings as jaLocaleStrings } from './ja';
export { localeStrings as koLocaleStrings } from './ko';
export { localeStrings as nlLocaleStrings } from './nl';
export { localeStrings as plLocaleStrings } from './pl';
export { localeStrings as ptLocaleStrings } from './pt';
export { localeStrings as ptbrLocaleStrings } from './pt-br';
export { localeStrings as zhcnLocaleStrings } from './zh-cn';
export { localeStrings as zhtwLocaleStrings } from './zh-tw';



// WEBPACK FOOTER //
// ./src/locales/index.js